/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ThunkStatus } from '../../../enums/ThunkStatus';
import { selectUsersData } from './users.slice';
import { fetchUsers } from './users.thunk';

/* Submission table hook */
export function useUsers(pagingSortingAndFiltering, organizationId) {
  const dispatch = useDispatch();
  const usersData = useSelector(selectUsersData);
  const { pageNumber, numberOfElementsOnAPage, sortColumn, sortOrder, filter } = pagingSortingAndFiltering;

  const getUsers = () =>
    dispatch(
      fetchUsers({
        organizationId,
        pagingSortingAndFiltering,
      }),
    );

  useEffect(() => {
    if (organizationId) getUsers();
  }, [
    organizationId,
    pageNumber,
    numberOfElementsOnAPage,
    sortColumn,
    sortOrder,
    filter,
  ]);

  return {
    ready: usersData.status === ThunkStatus.SUCCEEDED,
    isLoading: usersData.status === ThunkStatus.LOADING,
    items: usersData.rowItems,
    page: usersData.page,
    getUsers,
  };
}
